export default __webpack_public_path__ + "static/media/SSLW.2b027d38.png";